import React from 'react';
import { Link } from 'react-router-dom';
import AiToolWrapper from '../components/AiToolWrapper';
import ConverterControls from '../components/ToolEngine/Controls/ConverterControls';
import './ImageConverterPage.css'; // Create this simple CSS file next

export default function ImageConverterPage({ session }) {

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "FullMockup Image Converter",
    "applicationCategory": "UtilitiesApplication",
    "operatingSystem": "Web Browser",
    "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    "description": "Free online image converter. Convert JPG, PNG, WEBP files instantly."
  };

  return (
    <div className="converter-page fade-in">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>

      {/* HEADER */}
      <header className="converter-header">
        <h1>Universal Image Converter</h1>
        <p>Convert between JPG, PNG, GIF, and WebP instantly. Optimize file size without losing quality.</p>
      </header>

      {/* WORKSPACE */}
      <div className="converter-workspace">
        <AiToolWrapper
          title="Image Converter"
          apiEndpoint="/api/tools/convert-image"
          SettingsFormComponent={ConverterControls}
          session={session}
          actionName="Convert Image"
          // ★ CRITICAL: This tells the engine to use the Split Card layout
          layoutVariant="side-by-side" 
        />
      </div>

      {/* SEO SECTION */}
      <section className="tool-seo-section">
        <div className="seo-content-block">
            <h2>What is FullMockup's Image Converter?</h2>
            <p>FullMockup's <strong>Image Converter</strong> is a high-speed utility designed for modern web workflows. It solves the common problem of format incompatibility.</p>
        </div>
        <div className="tool-faq-grid">
            <div className="faq-card">
                <h3>Free?</h3>
                <p>Yes. 10 free credits daily for everyone.</p>
            </div>
            <div className="faq-card">
                <h3>Formats?</h3>
                <p>JPG, PNG, WebP, GIF supported.</p>
            </div>
            <div className="faq-card">
                <h3>Private?</h3>
                <p>Files deleted immediately after conversion.</p>
            </div>
        </div>
      </section>
    </div>
  );
}